import { Component, OnInit, Input, Output, ViewChild, ViewChildren, OnChanges, EventEmitter, OnDestroy, SimpleChange, SimpleChanges } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { AlarmData, AlarmService } from '../services/alarm.service';
import { DataSubscriptionService, ArcPlusPid } from '../services/data-subscription.service';
import { RealTimeUpdate } from '../custom-view-widget/custom-view-widget.component';
import { ModalSiteLinkComponent } from '../modal-site-link/modal-site-link.component';
import { MaterialModule } from '../modules/material.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-alarm-table',
  templateUrl: './alarm-table.component.html',
  styleUrls: ['./alarm-table.component.css']
})
export class AlarmTableComponent implements OnInit, AfterViewInit, RealTimeUpdate, OnChanges, OnDestroy
{
  @Input() sites: string[] = [];
  //@Input() pageSize: string[];
  severities: string[] = ['0','1'];//['Critical', 'Warning'];
  types: string[] = ['0', '1', '2', '3', '4'];//['High Limit', 'Low Limit', 'Status', 'System','User'];
  selectedSeverities: string[] = [];
  selectedTypes: string[] = [];
  @Output() close = new EventEmitter();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<AlarmData>;

  resultsLength = 0;
  private dataSource: MatTableDataSource<AlarmData>;
  private columnsToDisplay: string[] = [
    "siteName", "startTime", "duration", "severity", "type", "message", "clearedTime", "clearAlarm"
  ];
  private loading: boolean = false;
  private subscribedSites = new Map<string, Date>();

  constructor(private alarmService: AlarmService,
    private dataSubcription: DataSubscriptionService) { }

  ngOnInit()
  {
    //this.loadAlarms();
  }
  ngAfterViewInit() {
    this.paginator.page.subscribe(() => this.loadAlarms());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.loadAlarms();
    });
    this.paginator.pageIndex = 0;
    this.updateSubscriptions();
    this.loadAlarms();
  }
  ngOnChanges(changes: SimpleChanges)
  {
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.updateSubscriptions();
    this.loadAlarms();
  }

  updateSubscriptions() {
    
    if (!this.sites || this.sites.length==0) {
      this.dataSubcription.Remove(this);
      this.subscribedSites.clear();
    }
    // Remove subscriptions for sites no longer present
    this.subscribedSites.forEach((date,site) => {
      if (!this.sites.includes(site)) {
        this.dataSubcription.RemoveSite(this, site);
        this.subscribedSites.delete(site);
      }
    });

    // Add subscriptions for new sites
    this.sites.forEach(site => {
      if (!this.subscribedSites.has(site)) {
        this.dataSubcription.Add(this, [{
          site,
          block: "Alarm",
          channel: 0,
          pid: "UpdateTime"
        }]);
        this.subscribedSites.set(site, null);
      }
    });    
  }
  loadAlarms()
  {
    if (!this.paginator || !this.sort || !this.sites || this.sites.length === 0) return;
    if (this.loading) return; //We are already in the process of loading

    this.loading = true;

    const params = {
      sites: this.sites,
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      sortField: this.sort.active,
      sortDirection: this.sort.direction,
      startDate: this.startDate,
      endDate: this.endDate,
      types: this.selectedTypes,
      severities: this.selectedSeverities
    };

    //this.alarmService.getAlarmsPaged(params).subscribe(result => {
    //  this.loading = false;
    //  this.alarms = result.data;
    //  this.resultsLength = result.totalCount;
    //});
    // get the alarms for this site
    //this.alarmService.getAlarms(this.sites).subscribe((d) =>
    this.alarmService.getAlarmsPaged(params).subscribe(
    {
      next: d => {
        this.loading = false;
        this.resultsLength = d.totalCount;
        var alarmdata = d.data;
        this.dataSource = new MatTableDataSource<AlarmData>(alarmdata);
      },
        error: err => {
          this.loading = false;
        }
    });
  }

  ngOnDestroy()
  {
    this.dataSubcription.Remove(this);
  }

  //calculateAlarmFields(val: AlarmData)  MOVED TO ALARM SERVICE
  //{
  //  //// calculate the duration property
  //  //val.duration = (new Date(val.inactiveTime).valueOf() - new Date(val.startTime).valueOf()) / 1000;

  //  //// if it is less than 0 seconds or the inactive time is after the year 2100, make it -1.
  //  //// this alarm is not inactive
  //  //if (val.duration < 0 || new Date(val.inactiveTime).getFullYear() > 2100)
  //  //{
  //  //  val.duration = -1;
  //  //}

  //  // clean up the site name
  //  if (val.siteName)
  //  {
  //    val.siteName = val.siteName.replace(/\0/g, '');
  //  }

  //}

  //////////////////////////////////////////////////////////////////////////////
  // onClearAlarm
  //
  // Clicked the clear link on an alarm.
  //////////////////////////////////////////////////////////////////////////////
  onClearAlarm(alarm: AlarmData)
  {
    if (confirm("Are you sure you want to clear this alarm?"))
    {
      this.alarmService.ClearAlarm(alarm).subscribe();
    }
  }

  //////////////////////////////////////////////////////////////////////////////
  // Update
  //////////////////////////////////////////////////////////////////////////////
  Update(site: string, pid: string, channel: number, value: string)
  {
    console.log("" + site + pid + channel + value);

    switch (pid)
    {
      case "UpdateTime":
        // Parse the incoming value as the total seconds since 1/1/1970
        const newDate = new Date(Number(value) * 1000);
        const currentDate = this.subscribedSites.get(site);

        // Only update if newDate is valid and newer than currentDate
        if (!isNaN(newDate.getTime()) && (!currentDate || newDate > currentDate)) {
          console.log("subsribing to site:"+site+" datetime:"+newDate);
          this.subscribedSites.set(site, newDate);
          this.loadAlarms();
        }
        //this.alarmService.getAlarms(this.sites).subscribe((d) =>
        //{
        //  // for each element in the array, calculate the other alarm fields.
        //  d.map((val) =>
        //  {
        //    this.calculateAlarmFields(val);
        //  })

        //  this.dataSource.data = d;
        //  this.dataSource.paginator = this.paginator;
        //  this.dataSource.sort = this.sort;
        //});
        break;
    }
  }

  //////////////////////////////////////////////////////////////////////////////
  // CreateAlarmData
  //
  // Given a string from the web server, break it apart and create an AlarmData
  // object.
  //////////////////////////////////////////////////////////////////////////////
  CreateAlarmData(str: string): AlarmData
  {
    let alarm = new AlarmData();
    let split = str.split('~');

    alarm.siteId = "" + split[0];
    alarm.alarmId = +split[1];
    alarm.startTime = split[2];
    alarm.inactiveTime = split[3];
    alarm.clearedTime = split[4];
    alarm.channel = +split[5];
    alarm.type = split[6];
    alarm.severity = split[7];
    alarm.message = split[8];
    alarm.siteName = split[9];
    alarm.duration = +split[10];
    //this.calculateAlarmFields(alarm);

    return alarm;
  }

  //////////////////////////////////////////////////////////////////////////////
  // FindAlarm
  //
  // Given an alarm id, find the index of that alarm in the dataSource.  If it
  // is not found, return -1.
  //////////////////////////////////////////////////////////////////////////////
  FindAlarm(id: number): number
  {
    let index = -1;

    let a = this.dataSource.data.find((obj, i) =>
    {
      if (obj.alarmId == id)
      {
        index = i;
      }
      return obj.alarmId == id;
    });

    return index;
  }

  /**
   * 
   * @param $event 
   */
  onClick($event: Event)
  {
    event.stopPropagation();
  }

  onClearAll()
  {
    if (!confirm("Are you sure you want to clear all alarms?"))
    {
      return;
    }

    //get the current set of rows displayed in the table.
    let rows = this.dataSource.data;

    let sites = new Set<number>();
    rows.forEach(alarm =>
    {
      sites.add(+alarm.siteId);
    });
    var siteArray = Array.from(sites);
    this.alarmService.ClearAllAlarms(siteArray).subscribe();
  }

  /**
   * User clicked the close button.
   */
  onClose()
  {
    this.close.emit();
  }

  startDate: Date | null = null;
  endDate: Date | null = null;

  applyFilter() {
    this.paginator.pageIndex = 0;
    this.loadAlarms();
    //this.dataSource.filterPredicate = (data: AlarmData, filter: string) => {
    //  const rowDate = new Date(data.startTime);
    //  const { start, end } = JSON.parse(filter);

    //  return (!start || rowDate >= new Date(start)) &&
    //    (!end || rowDate <= new Date(end));
    //};

    //this.dataSource.filter = JSON.stringify({
    //  start: this.startDate,
    //  end: this.endDate
    //});
  }
}
